import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ConsentService } from '@navfleet/client/cookie-consent/domain/data-access';
import { CookieConsentDialogComponent } from '@navfleet/client/cookie-consent/ui/cookie-consent-dialog';
import { toBooleanSignal } from '@navfleet/client/shared/util/functions';

@Component({
    selector: 'fl-cookie-consent-container',
    templateUrl: './cookie-consent.container.html',
    imports: [CookieConsentDialogComponent],
})
export class CookieConsentContainer {
    public readonly service = inject(ConsentService);

    public readonly consent = toSignal(this.service.consent$);
    public readonly show = toBooleanSignal(this.service.show$);
}
